(() => {
  'use strict';
  function initialise(section) {
    if (section.dataset.complementReady) return;
    const selected = section.querySelector('[data-complement-selected]');
    const variant = section.querySelector('[data-complement-variant]');
    const quantity = section.querySelector('[data-complement-quantity]');
    const minus = section.querySelector('[data-complement-minus]');
    const plus = section.querySelector('[data-complement-plus]');
    const total = section.querySelector('[data-complement-total]');
    const feedback = section.querySelector('.complement-feedback');
    if (!selected || !variant || !quantity || !minus || !plus || !total) return;
    section.dataset.complementReady = 'true';
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency', currency: section.dataset.currency || window.Shopify?.currency?.active || 'EUR'
    });
    let busy = false;
    function current() {
      const option = variant.selectedOptions[0];
      const rawMax = Number(option?.dataset.max);
      const maximum = Number.isFinite(rawMax) ? Math.max(0, Math.floor(rawMax)) : 99;
      const available = Boolean(option && !option.disabled && maximum > 0 && Number(option.dataset.complementPrice) > 0);
      const count = Math.min(Math.max(1, Math.floor(Number(quantity.value) || 1)), Math.max(1, maximum));
      return { option, maximum, available, count };
    }
    function paint(notify = false) {
      const { option, maximum, available, count } = current();
      quantity.value = String(count);
      quantity.max = String(Math.max(1, maximum));
      quantity.disabled = busy || !available;
      variant.disabled = busy;
      selected.disabled = busy || (!available && !selected.checked);
      minus.disabled = busy || !available || count <= 1;
      plus.disabled = busy || !available || count >= maximum;
      section.classList.toggle('is-selected', selected.checked);
      section.setAttribute('aria-busy', String(busy));
      total.textContent = '+ ' + formatter.format((Number(option?.dataset.complementPrice) || 0) * count / 100);
      total.hidden = !available;
      if (feedback) {
        feedback.hidden = available;
        feedback.textContent = available ? '' : 'Sacs indisponibles pour le moment.';
      }
      if (notify) document.dispatchEvent(new CustomEvent('cocon:purchase-complement-changed'));
    }
    selected.addEventListener('change', () => paint(true));
    variant.addEventListener('change', () => paint(true));
    quantity.addEventListener('change', () => paint(true));
    quantity.addEventListener('input', () => { if (quantity.value !== '') paint(true); });
    minus.addEventListener('click', () => { quantity.value = String(current().count - 1); paint(true); });
    plus.addEventListener('click', () => { quantity.value = String(current().count + 1); paint(true); });
    document.addEventListener('cocon:purchase-busy', event => { busy = Boolean(event.detail?.busy); paint(); });
    paint();
  }
  const initialiseAll = scope => scope.querySelectorAll('[data-cocon-complement]').forEach(initialise);
  initialiseAll(document);
  document.addEventListener('shopify:section:load', event => initialiseAll(event.target));
})();
